<div class="container-sobre">
  <div class="cabecalho">
    <img class="cabecalho-imagem" src="imagem/ifpe.png" alt="Logo do IFPE" />
    <div class="cabecalho-ifpe">
      <p class="cabecalho-ifpe-a">
        <strong>
          Instituto Federal de Educação, Ciência e Tecnologia - IFPE</strong
        >
      </p>
      <p class="cabecalho-ifpe-a">
        <strong>Cursos:</strong> Informática para Internet (IPI) / Sistemas para
        Internet (TSI)
      </p>
      <p class="cabecalho-ifpe-a">
        <strong>Componentes:</strong> Lógica de Programação e Estrutura de Dados
        | Programação Imperativa
      </p>
      <p class="cabecalho-ifpe-a">
        <strong>Aluno:</strong> Bruno Wilian Crispim da Silva
      </p>
    </div>
  </div>

  <section class="container-principal">
    <div class="campo-text">
      <h1 class="conteudo-principal-titulo">Sobre</h1>
      <h3 class="conteudo-principal-subtitulo">1. Sobre o Projeto</h3>
      <p class="conteudo-principal-paragrafo">
        Jogo desenvolvido por estudante do Instituto Federal de Pernambuco -
        Campus Igarassu, utilizando recursos do compilador front-end Svelte para
        construir componentes através das linguagens JavaScript (Programação),
        HTML (Marcação de HiperTexto) e CSS (Estilo).
      </p>
      <h3 class="conteudo-principal-subtitulo">2. Sobre o Jogo</h3>
      <p class="conteudo-principal-paragrafo">
        O jogo da velha é um jogo de regras extremamente simples, que é
        facilmente aprendido pelos seus jogadores e tem como objetivo fazer uma
        sequência de três símbolos iguais, seja em linha vertical, horizontal ou
        diagonal, enquanto tenta prever o movimento do adversário. Além disso, é
        uma boa oportunidade para estimular o raciocínio lógico, aprender a
        formar sequência e a ter paciência.
      </p>
    </div>
  </section>
</div>
